// extracted by mini-css-extract-plugin
export default {"container":"ProjectList_container__snKDp","heading":"ProjectList_heading__6kYr2","projectList":"ProjectList_projectList__BHjXW"};